<template>
  <div class="assessSuccess">
    <nav-bar title="问题反馈详情"></nav-bar>
    <div class="assess-wt" v-for="(item,i) in list" :key="i" >
      <van-cell
        title-class="title"
        value-class="value"
        title="问题类型"
        is-link
        :value="item.questionType"
      />
      <van-cell
        title-class="title"
        value-class="value"
        title="订单编号"
        is-link
        :value="item.orderSn"
      />
      <van-cell
        title-class="title"
        value-class="value"
        title="反馈时间"
        is-link
        :value="item.addTime"
      />
      <div class="complaint">
        {{item.content}}
      </div>
      <div class="complaint-img">
        <img src="../../assets/icon/bianzu.png" />
        <img src="../../assets/icon/bianzu.png" />
      </div>
      <p class="complaint-p">处理结果</p>
      <div class="complaint">
        {{item.processContent}}
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
import { Cell } from "vant";
export default {
  name: "questionfeedbackdetails",
   data() {
   	return {
   		list: [],
   	};
   },
   created(){
	 this.listadd()  
   },
  methods: {
	  listadd(){
		  // console.log(JSON.parse(this.$route.params.id) ,"6666")
		   this.$axios({
		   	url: "/vedm/accountCommonApp/getAccountEvaluationById/"+this.$route.params.id,
		   	method: "get",
		   	headers: {
		   		Authorization: localStorage.getItem('token') //token换成从缓存获取
		   	},
		   }).then(res => {
		   	this.list.push( res.data.data)
		   })
		  
		  
	  },
	
  },
  components: {
    NavBar,
    "van-cell": Cell
  }
};
</script>

<style scoped lang="less">
.assessSuccess {
  background: rgba(247, 247, 247, 1);
  .assess-wt {
    margin-top: 10px;
  }
  .complaint {
    width: 90%;
    height: 120px;
    background: #ccc;
    border-radius: 10px;
    margin: 20px auto;
    line-height: 40px;
    text-indent: 1em;
	font-size: 14px;
  }
  .complaint-p {
    font-size: 16px;
    margin-left: 20px;
    margin-top: 40px;
  }
  .complaint-img {
    overflow: hidden;
  }
  .complaint-img img {
    width: 60px;
    height: 60px;
    float: left;
    margin-left: 20px;
  }
  .project {
    align-items: center;

    .number {
      display: block;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }

    .name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }

    .tag {
      margin-left: 10px;
    }

    .tagRight {
      background: rgba(255, 149, 0, 0.1);
      border-radius: 2px;
      border: 1px solid rgba(255, 149, 0, 1);
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 149, 0, 1);
      margin-right: 5px;
    }

    .spanRight {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }
  }

  .happening {
    width: 375px;
    background: rgba(255, 255, 255, 1);
    padding: 15px;
    margin-bottom: 12px;

    p {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      margin: 0;
      margin-bottom: 20px;
    }

    .div {
      width: 104px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid rgba(232, 233, 235, 1);
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }

    .options {
      width: 345px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 24px;
    }

    .item {
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 6px;
      padding: 0 20px;
      border: 1px solid rgba(232, 233, 235, 1);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(98, 104, 112, 1);
    }
  }
}
</style>
